const ETH_MAINNET_ID = 1;
const ETH_RINKEBY_ID = 4;
const MATIC_MAINNET_ID = 137;
const MATIC_MUMBAI_ID = 80001;

const NetworkUtil = {
  supportedNetworks: function () {
    return [
      ETH_RINKEBY_ID,
      MATIC_MUMBAI_ID,
      MATIC_MAINNET_ID,
    ];
  },

  isSupportedNetwork: function (netId) {
    return this.supportedNetworks().includes(netId);
  },

  isMainnet: function (netId) {
    return netId === ETH_MAINNET_ID || netId === MATIC_MAINNET_ID;
  },

  isTestnet: function (netId) {
    return !this.isMainnet(netId);
  },

  getExplorerLink: function (netId) {
    switch (netId) {
      case ETH_MAINNET_ID:
        return 'https://etherscan.io/tx/';
      case ETH_RINKEBY_ID:
        return 'https://rinkeby.etherscan.io/tx/';
      case MATIC_MAINNET_ID:
        return 'https://explorer-mainnet.maticvigil.com/tx/';
      case MATIC_MUMBAI_ID:
        return 'https://explorer-mumbai.maticvigil.com/tx/';
      default:
        return null;
    }
  },

  getAccountLink: function (netId, account) {
    switch (netId) {
      case ETH_MAINNET_ID:
        return `https://etherscan.io/address/${account}`;
      case ETH_RINKEBY_ID:
        return `https://rinkeby.etherscan.io/address/${account}`;
      case MATIC_MAINNET_ID:
        return `https://explorer-mainnet.maticvigil.com/address/${account}/transactions`;
      case MATIC_MUMBAI_ID:
        return `https://explorer-mumbai.maticvigil.com/address/${account}/transactions`;
      default:
        return null;
    }
  },
};

export default NetworkUtil;